<template>
  <v-container
    id="user-profile-view"
    fluid
    tag="section"
    class="hero"
    fill-height
  >
    <div class ="red-text">
    <ul><li><span style="font-size: 16pt; color: #0000ff;">
This portal provides Lecture/Test Timetable, Performance Reports, Downloads, and other important details for students.
</span></li></ul>
<div><span style="font-size: 16pt; color: #0000ff;"></span></div>
<div><ul><li><span style="font-size: 16pt; color: #0000ff;">
For new users, the login ID and password will be generated within 24-48 hours after enrollment.</span></li></ul></div>
<div><span style="font-size: 16pt; color: #0000ff;"></span></div>
<div><ul><li><span style="font-size: 16pt; color: #0000ff;">
In case of any login-related issues, please contact us on ‪+91 9137852270‬
</span></li></ul></div>
    </div>
    <v-row justify="center" align="center">
    
      <v-col cols="12" md="4">
        
        <app-card class=" text-center" color="rgb(255, 255, 255, 0.4)">
          <v-avatar
            class="rounded-circle elevation-6 mt-n12 d-inline-block"
            color="white"
            size="85"
          >
            <v-icon size="70" color="primary"> mdi-face-profile </v-icon>
          </v-avatar>

          <v-card-text class="text-center">
            <v-form v-model="valid">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      prepend-inner-icon="mdi-account"
                      v-model="userName"
                      :rules="nameRules"
                      :counter="50"
                      label="User Name"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      prepend-inner-icon="mdi-account-key"
                      v-model="password"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="nameRules"
                      :type="show1 ? 'text' : 'password'"
                      name="password"
                      label="Password"
                      counter
                      @click:append="show1 = !show1"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <v-row>
              <v-col>
                <v-btn
                  class="mr-0"
                  color="primary"
                  @click="signIn"
                  min-width="100"
                  :disabled="!valid"
                  rounded
                >
                  Login
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn
                  text
                  class="mr-0"
                  color="information"
                  @click="dialogResetPassword = true"
                  min-width="100"
                  rounded
                >
                  Forgot Credentials
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </app-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogResetPassword" width="400">
      <v-form v-model="validEdit">
        <v-card>
          <v-card-title>
            <span class="text-h5">Resend Credentials</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    prepend-inner-icon="mdi-account"
                    v-model="st_id"
                    label="Student ID"
                    :rules="reqRules"
                    :counter="50"
                    maxlength="50"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              x-large
              color="blue darken-1"
              text
              @click="dialogResetPassword = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="blue darken-1"
              :loading="saveLoading"
              text
              :disabled="!validEdit"
              @click="resetPassword"
              x-large
            >
              Resend
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>
<style scoped>
.hero {
  background: lightgrey;
  
  height: 80vh;
}
p {
  margin-top: 0px;   
  margin-bottom: 0px; 
}
.red-text{
  align-self:flex-start;
  color:red;
  margin-left: 400px;
  margin-right: 150px;
    font-size: 12px;
  margin-bottom:20px;
}
</style>
<script>
import { get, sync } from "vuex-pathify";
import { showSnackbar } from "../util/globalActions";

import axios from "axios";
export default {
  name: "LoginView",
  data: () => ({
    saveLoading: false,
    validEdit: false,
    dialogResetPassword: false,
    valid: false,
    show1: false,
    st_id: "",
    isLogin: false,
    userName: "",
    password: "",
    message: "",
    snackbar: false,
    nameRules: [(v) => !!v || "Field is required"],
    reqRules: [
      (v) => !!v || "Field is required",
      (v) => (v && v.includes("S")) || "Only Student ID Allowed",
    ],
  }),
  computed: {
    apiUrl: get("app/apiUrl"),
    ...sync("app", ["items"]),
  },
  methods: {
    getMenu() {
      const self = this;
      if (localStorage.getItem("user") || false) {
        this.isLogin = true;
      }
      axios({
        url: self.apiUrl + "api/Menus/OfUser",
        method: "GET",
      })
        .then(function(res) {
          res.data.forEach((element) => {
            if (element.menumodel === null || element.menumodel.length === 0)
              delete element.menumodel;
            else {
              element.menumodel.forEach((element1) => {
                if (
                  element1.menumodel === null ||
                  element1.menumodel.length === 0
                )
                  delete element1.menumodel;
              });
            }
          });
          self.items = res.data;
        })
        .catch(function(err) {
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },

    signIn() {
      const self = this;

      var data = {
        username: self.userName,
        password: self.password,
      };
      axios({
        url: self.apiUrl + "api/Users/login",
        data: data,
        method: "POST",
      })
        .then(function(response) {
          self.snackbar = false;

          if (response.data.status === "OK") {
            response.data.data.userName = data.username;
            self.$store.dispatch("user/login", response.data.data).then(() => {
              self.getMenu();
              window.location = "/";
              //self.$router.replace({ name: "Dashboard" });
            });
          } else {
            showSnackbar({ message: response.data.message });
          }
        })
        .catch(function(err) {
          self.message = err.status;
          showSnackbar({ message: "Invalid response" });
        });
    },
    resetPassword() {
      const self = this;
      self.saveLoading = true;
      var data = {
        username: self.st_id,
      };
      axios({
        url: self.apiUrl + "api/Users/resetPassword",
        data: data,
        method: "POST",
      })
        .then(function(response) {
          self.snackbar = false;

          if (response.data.status === "OK") {
            showSnackbar({ message: response.data.message });
            self.dialogResetPassword = false;
            self.saveLoading = false;
          } else {
            showSnackbar({ message: response.data.message });
            self.saveLoading = false;
          }
        })
        .catch(function(err) {
          self.saveLoading = false;
          self.message = err.status;
          showSnackbar({ message: "Invalid response" });
        });
    },
  },
};
</script>
